import React, { useEffect } from "react";
import { useField } from "react-final-form";
import { required, TextInput } from "react-admin";

interface ICommercialDocumentNoteInput {
  index: number;
  rateChartId: any;
}

const CommercialDocumentNoteInput = ({
  index,
  rateChartId,
}: ICommercialDocumentNoteInput) => {
  const noteField = useField(`commercialDocumentNotes[${index}].note`);
  const rateChartField = useField(
    `commercialDocumentNotes[${index}].rateChartId`
  );

  useEffect(() => {
    noteField.input.onChange(null);
    rateChartField.input.onChange(rateChartId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TextInput
      label="Note"
      source={`commercialDocumentNotes[${index}].note`}
      onChange={(e: any) => {
        rateChartField.input.onChange(rateChartId);
      }}
      validate={required()}
    />
  );
};

export default CommercialDocumentNoteInput;
